const SortImgEls = document.querySelectorAll('.js-sort-img');

if (SortImgEls) {
  [...SortImgEls].forEach((item) => {
    item.addEventListener('click', () => {
      if (item.classList.contains('k-sort--none')) {
        item.classList.remove('k-sort--none');
        item.classList.add('k-sort--up');
        item.previousElementSibling.classList.add('js-active');
      } else if (item.classList.contains('k-sort--up')) {
        item.classList.remove('k-sort--up');
        item.classList.add('k-sort--down');
      } else if (item.classList.contains('k-sort--down')) {
        item.classList.remove('k-sort--down');
        item.classList.add('k-sort--both');
      } else {
        item.classList.remove('k-sort--both');
        item.classList.add('k-sort--none');
        item.previousElementSibling.classList.remove('js-active');
      }
    });
  });
}
